import React from "react";
import { useSearchParams } from "react-router-dom";
import { useHotel } from "@/hooks/useHotel";
import { FeedbacksNavigation, FeedbacksType } from "./FeedbacksNavigation";
import { RequestsFeedbacks } from "./RequetsFeedbacks";
import { CommunicationFeedbacks } from "./CommunicationFeedbacks";
import { ReservationFeedbacks } from "./ReservationFeedbacks";
import { useAccessCapabilities } from "@/hooks/useAccessCapabilities";

export const FeedbacksPage = () => {
  const { hotelId, isLoading, error } = useHotel();
  const [searchParams] = useSearchParams();
  const { capabilities } = useAccessCapabilities();

  const defaultTab = capabilities.canUseRequestsSystem
    ? FeedbacksType.REQUESTS
    : FeedbacksType.COMMUNICATIONS;
  const requestedTab = searchParams.get("tab") as FeedbacksType | null;
  const activeTab =
    !capabilities.canUseRequestsSystem &&
    requestedTab === FeedbacksType.REQUESTS
      ? defaultTab
      : requestedTab || defaultTab;

  if (isLoading) {
    return <div>Loading</div>;
  }

  if (error) {
    return (
      <div className="text-destructive py-4 text-center">
        Error loading hotel: {error.message}
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-6 p-0">
      <FeedbacksNavigation />

      {capabilities.canUseRequestsSystem &&
      activeTab === FeedbacksType.REQUESTS ? (
        <RequestsFeedbacks hotelId={hotelId!} />
      ) : null}

      {activeTab === FeedbacksType.COMMUNICATIONS && (
        <CommunicationFeedbacks hotelId={hotelId!} />
      )}

      {activeTab === FeedbacksType.RESERVATIONS && (
        <ReservationFeedbacks hotelId={hotelId!} />
      )}
    </div>
  );
};
